export default {
  on: true,
  cache: true,
  auth: true,
  intercept: false,
  title:'默认配置优先级'
} as TCommon.RouteConfig
